import { defineMessages } from 'react-intl'

/** LuxPlus+ membership copy — see `docs/product-taxonomy.md` §4. */
const luxPlusGlossaryMessages = defineMessages({
  luxPlusProgramName: {
    defaultMessage: 'LuxPlus+',
    id: 'wihKYxaip1tm0eYw-O0P',
  },
  luxPlusYearlyMembership: {
    defaultMessage: 'LuxPlus+ Yearly Membership',
    id: 'ULo9gnL1uIK6CoWu6hg1',
  },
  luxPlusMonthlyMembership: {
    defaultMessage: 'LuxPlus+ Monthly Membership',
    id: 'l-UmUgySYbCf9cnK1xth',
  },
  luxPlusFreePreview: {
    defaultMessage: 'LuxPlus+ Free Preview',
    id: 'o-DAWTTHNBRoW6Q3xZNr',
  },
  startFreePreview: {
    defaultMessage: 'Start Free Preview now',
    id: 'mjE2LdFDfUGLQ1LitKZ-',
  },
  startDurationFreePreview: {
    defaultMessage: 'Start {duration}-day Free Preview',
    id: 'z30GZaML6-78YeeI2q6T',
  },
  vipTravelClubPreview: {
    defaultMessage: 'VIP Travel Club Preview',
    id: 'fBlcyEqJoo5_vRHKDIVg',
  },
  earlyAccess: {
    defaultMessage: 'Early Access',
    id: '-BoyjWsFd0KgblxBsfC1',
  },
  earlyAccessWithLuxPlus: {
    defaultMessage: 'Early access with LuxPlus+',
    id: '0VnrinXBoyzq4Yic246V',
  },
  memberOnlyOffer: {
    defaultMessage: 'Member-only offer',
    id: 'vdTR3nC52iYAudXEHj-f',
  },
  memberPrice: {
    defaultMessage: 'Member price',
    id: 'xMo2bIO0Fl_R-JFwE5F1',
  },
  memberPriceWithName: {
    defaultMessage: '{programName} member price',
    id: 'QcN-1ofgEwg68jC0wq3T',
  },
  memberInclusions: {
    defaultMessage: 'Member inclusions',
    id: 'VGXYAy1-9fkybh_qiaRh',
  },
  activateFreeMembership: {
    defaultMessage: 'Activate your free membership',
    id: 'imyXSQMZhDmz-nMTsR2f',
  },
  becomeAMember: {
    defaultMessage: 'Become a member',
    id: 'Ibbk64pzWK9gYnBkTdMw',
  },
  manageMembership: {
    defaultMessage: 'Manage membership',
    id: 'nwHZAIziJe1M8RdFZP8V',
  },
})

export default luxPlusGlossaryMessages
